module.exports = __webpack_public_path__ + "img/home-delivery_small@2x.f5807b00.jpg";